<template>
  <v-container fluid id="dashboard-wrapper" class="h-100 ps-4">
    <v-sheet class="d-flex flex-column h-100">
      <div class="d-flex align-center my-2">
        <v-btn-toggle
          background-color="transparent"
          :value="selectedDashboard"
          dense
          id="dashboard-tabs"
          color="primary"
          class="d-flex"
          style="gap: 8px; overflow-x: auto"
          mandatory>
          <div  v-for="(tab, index) in tabs" :key="index">
            <v-tooltip  top>
                  <template v-slot:activator="{ on, attrs }">
            <span  v-bind="attrs"
            v-on="on" >
              <v-btn
            :value="tab.index"
            :key="tab.name"
            :disabled="tab.disabled"
            :class="['',{'text--disabled':tab.disabled}]"
            :ripple="{ class: 'primary--text' }"
            outlined
            @click="$router.push(tab.path)">
            <!-- <v-icon small class="mr-1">{{ tab.icon }}</v-icon> -->
            <span
              class="me-2 tab-icon"
              :style="{
                '-webkit-mask-image': `url(${getIcons(tab.icon)})`,
                'mask-image': `url(${getIcons(tab.icon)})`
              }"
              aria-hidden="true"></span>
            <span> {{ tab.title }} </span>
          </v-btn>
            </span>
                  </template>
                  <span>{{tab.disabled?'Permission Required':tab.title}}</span>
                </v-tooltip>
          </div>

        </v-btn-toggle>
        <v-spacer></v-spacer>
        <v-btn class="mx-2" color="primary" rounded v-if="isCathodicTab">
          <v-icon left>mdi-autorenew</v-icon> Reset All
        </v-btn>
        <v-btn color="primary" outlined rounded @click="openFilters" v-if="showGlobalFilters">
          <v-icon left>mdi-filter</v-icon> Filters
        </v-btn>
      </div>

      <keep-alive>
        <router-view
          ref="inspectionDashboards"
          class="flex-grow-1"
          :selectedFilters="selectedFilters"
          @viewerOpened="handleViewerOpened">
        </router-view>
      </keep-alive>

      <DashboardFilters
        ref="dashboardFilters"
        :viewerOpened="isViewerOpened"
        @filtersChanges="handleFiltersChanges"
        @openViewer="openViewer"></DashboardFilters>
    </v-sheet>
  </v-container>
</template>

<script>
  import levelsService from '@/features/Admin/services/levels.service';
  import DashboardFilters from '../components/DashboardFilters.vue';
import { $has } from '@/utils';
import permissions from '@/features/Share/config/permissions';

  export default {
    name: 'DashboardView',
    data() {
      return {
        isViewerOpened: false,
        selectedFilters: {},
      };
    },
    methods: {
      changeSeverity(item, newSeverity) {
        item.severity = newSeverity;
      },
      openFilters() {
        this.$refs.dashboardFilters.open();
      },
      handleViewerOpened(value) {
        this.isViewerOpened = value;
      },
      openViewer() {
        this.$refs.inspectionDashboards.openViewer();
      },
      handleFiltersChanges(selected_filters) {
        this.selectedFilters = selected_filters;
      },
      getIcons(name) {
        // Check if name already has an extension
        const hasExtension = /\.\w+$/.test(name);
        const fileName = hasExtension ? name : `${name}.svg`;
        return require(`@Assets/svgs/${fileName}`);
      },
    },
    created() {
      levelsService.fetchAssetLevelsParsed(this.$route.params.id).then((levels) => {
        this.$store.state.levels = levels;
      });
      this.$store.commit('SET_VIEWER_TYPE', '2d');
    },
    computed: {
      tabs() {
        return [
          {
            index: 0,
            path: `/${this.$route.params.id}/dashboard/inspection/inspection`,
            title: 'Inspection',
            name: 'inspection',
            icon: 'inspection',
            icon_active: 'inspection_white',
            disabled:!$has(permissions.Dashboard.Inspections_Inspection),
            useGlobalFilters: true,
          },
          {
            index: 1,
            path: `/${this.$route.params.id}/dashboard/inspection/rbi`,
            title: 'RBI',
            name: 'rbi',
            icon: 'RBI',
            icon_active: 'RBI_white',
            disabled:!$has(permissions.Dashboard.Inspections_RBI),
            useGlobalFilters: true,
          },
          {
            index: 2,
            path: `/${this.$route.params.id}/dashboard/inspection/thickness`,
            title: 'Thickness',
            name: 'thickness',
            icon: 'thickness',
            icon_active: 'thickness_white',
            disabled:!$has(permissions.Dashboard.Inspections_Thickness),
            useGlobalFilters: true,
          },
          // {
          //   index: 3,
          //   path: `/${this.$route.params.id}/dashboard/inspection/ai-inspect`,
          //   title: 'AI Inspect',
          //   name: 'ai-inspect',
          //   icon: 'AI',
          //   icon_active: 'AI_white',
          //   disabled:!$has(permissions.Dashboard.Inspections_AIInspect),
          //   useGlobalFilters: false,
          // },
          {
            index: 4,
            path: `/${this.$route.params.id}/dashboard/inspection/ai-analysis`,
            title: 'AI Analysis',
            name: 'ai-analysis',
            routeNames: ['ai-analysis', 'ai-analysis-job'],
            icon: 'AI',
            icon_active: 'AI_white',
            // Dedicated permission is API ask 9 (AVA-531); reuse AI Inspect until it is seeded.
            disabled: !$has(permissions.Dashboard.Inspections_AIInspect),
            useGlobalFilters: false,
          },
          {
            index: 5,
            path: `/${this.$route.params.id}/dashboard/inspection/cathodic`,
            title: 'Cathodic Protection',
            name: 'cathodic',
            icon: 'Cathodic',
            icon_active: 'Cathodic_white',
            disabled:!$has(permissions.Dashboard.Inspections_CathodicProtection),
            useGlobalFilters: true,
          },
          {
            index: 6,
            path: `/${this.$route.params.id}/dashboard/inspection/iows`,
            title: 'IOWs',
            name: 'iows',
            icon: 'IOWS',
            icon_active: 'IOWS_white',
            disabled:!$has(permissions.Dashboard.Inspections_IOWs),
            useGlobalFilters: true,
          },
           {
            index: 7,
            path: `/${this.$route.params.id}/dashboard/inspection/corrosion-analyser`,
            title: 'Corrosion Analyser',
            name: 'corrosion-analyser',
            icon: 'CorrosionAnalyser',
            icon_active: 'CorrosionAnalyser_white',
            disabled:!$has(permissions.Dashboard.Inspections_CorrosionAnalyser),
            useGlobalFilters: false
          },
          {
            index: 8,
            path: `/${this.$route.params.id}/dashboard/inspection/coating-analyser`,
            title: 'Coating Analyser',
            name: 'coating-analyser',
            icon: 'CoatingAnalyser_active.png',
            icon_active: 'CoatingAnalyser_white.png',
            disabled:!$has(permissions.Dashboard.Inspections_CoatingAnalyser),
            useGlobalFilters: false
          }
        ];
      },
      routeTab() {
        return this.tabs.find((a) => (a.routeNames || [a.name]).includes(this.$route.name)) ?? null;
      },
      selectedDashboard() {
        if (this.routeTab && !this.routeTab.disabled) {
          return this.routeTab.index;
        }
        let tabIndex = this.tabs.filter(t=>!t.disabled)[0]?.index ?? null;

        return tabIndex
      },
      showGlobalFilters() {
        return this.tabs.find(t => t.index == this.selectedDashboard)?.useGlobalFilters ?? false;
      },
      isCathodicTab() {
        return this.tabs.find((t) => t.index === this.selectedDashboard)?.name === 'cathodic';
      },
    },
    components: {
      DashboardFilters,
    },
    watch: {
      selectedDashboard: {
        handler(newIndex) {
          if (newIndex === null) {
            this.$router.push('/');
          }
        },
        immediate: true,
      },
      // The bare dashboard path and the hidden AI Inspect route have no tab; open the first permitted tab instead.
      '$route.name': {
        handler(name) {
          if (!['default', 'ai-inspect'].includes(name) || this.selectedDashboard === null) return;
          this.$router.replace(this.tabs.find((t) => t.index === this.selectedDashboard).path);
        },
        immediate: true,
      },
    },
  };
</script>
<style lang="scss">
  #dashboard-wrapper {
    font-family: 'Popins', sans-serif;

    #dashboard-tabs {
      & .v-btn {
        text-transform: none !important;
        border-radius: 8px !important;
        letter-spacing: normal !important;
        font-weight: 500;
        font-size: 13px;
        height: 40px;
        padding: 0 16px;
        transition: all 0.2s ease;

        // Inactive state - pill-shaped with border
        background-color: #f5f5f5 !important;
        border: 1px solid #e0e0e0 !important;
        color: #666 !important;

        & i {
          color: #666 !important;
        }

        // Icon styling - CSS mask technique for dynamic coloring
        // The SVG acts as a mask shape, background-color fills it
        // Using <span> instead of <img> because span has no image content to render,
        // so only the background-color (through the mask) will be visible
        & .tab-icon {
          // Fixed dimensions (span has no intrinsic size)
          display: inline-block;
          width: 22px;
          height: 22px;

          // Mask properties
          -webkit-mask-size: contain;
          mask-size: contain;
          -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
          -webkit-mask-position: center;
          mask-position: center;

          // Icon takes on the text color (gray for inactive)
          background-color: #666;
          transition: background-color 0.2s ease;
        }

        // Hide default Vuetify overlay
        &:before {
          display: none !important;
        }

        // Hover state (inactive only)
        &:hover:not(.v-btn--active) {
          background-color: #eeeeee !important;
          border-color: #d0d0d0 !important;
        }

        // Disabled state
        &.v-btn--disabled {
          opacity: 0.5;
          color: rgba(158, 158, 158, 0.5) !important;

          & .tab-icon {
            background-color: rgba(158, 158, 158, 0.5);
          }
        }

        // Active state - outlined with primary border
        &.v-btn--active {
          background-color: transparent !important;
          border: 2px solid var(--v-primary-base) !important;
          color: var(--v-primary-base) !important;
          font-weight: 600;
          box-shadow: none !important;

          & i {
            color: var(--v-primary-base) !important;
          }

          // Icon matches primary text color exactly
          & .tab-icon {
            background-color: var(--v-primary-base);
          }
        }
      }
    }
  }

  // Dark theme support for dashboard tabs
  .theme--dark #dashboard-tabs {
    & .v-btn {
      background-color: rgba(255, 255, 255, 0.08) !important;
      border-color: rgba(255, 255, 255, 0.12) !important;
      color: rgba(255, 255, 255, 0.7) !important;

      & i {
        color: rgba(255, 255, 255, 0.7) !important;
      }

      // Icon matches light text for dark theme
      & .tab-icon {
        background-color: rgba(255, 255, 255, 0.7);
      }

      &:hover:not(.v-btn--active) {
        background-color: rgba(255, 255, 255, 0.12) !important;
        border-color: rgba(255, 255, 255, 0.2) !important;
      }

      &.v-btn--active {
        background-color: transparent !important;
        border-color: var(--v-primary-base) !important;
        color: var(--v-primary-base) !important;

        & i {
          color: var(--v-primary-base) !important;
        }

        // Icon matches primary text color exactly
        & .tab-icon {
          background-color: var(--v-primary-base);
        }
      }
    }
  }
</style>
